import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin, Icon } from 'antd';
import SubscriptionChart from '../../../components/SubscriptionChart';
import { userSubscriptionsSummarySelector, loadingUserSubscriptionsSelector } from '../../../../User/UserSelectors';
import '../../BrokerageSubscriptions/BrokerageSubscriptions.scss';
import { isPurchaseEnabled } from '../../../../../../../utils/featureGates';
import { getPartnerContactEmail } from '../../../../../../../themes/partnerTheme';

const MySummary = ({ userSubscriptionsSummary = {}, loading }) => {
  const [summary, setSummary] = useState({ total: 0, remaining: 0, expired: 0 });

  useEffect(() => {
    if (userSubscriptionsSummary) {
      setSummary(s => ({ ...s, ...userSubscriptionsSummary }));
    }
  }, [userSubscriptionsSummary]);

  const legendData = [
    { name: 'Remaining', value: summary.remaining, color: '#00685e' },
    { name: 'Expired', value: summary.expired, color: '#d4a5a7' }
  ];

  const statCards = [
    { label: 'TOTAL SUBSCRIPTIONS', value: summary.total, mod: 'yellow' },
    { label: 'REMAINING', value: summary.remaining, mod: 'teal' },
    { label: 'EXPIRED', value: summary.expired, mod: 'orange' }
  ];

  return (
    <Spin spinning={loading}>
      <div className="bsub-top bsub-top--my-subscriptions">
        {/* Left: summary card */}
        <div className="bsub-summary-card">
          <h2 className="bsub-summary-title">SUBSCRIPTIONS SUMMARY</h2>
          <div className="bsub-chart-wrap">
            <SubscriptionChart
              summary={{ total: summary.total, remaining: summary.remaining }}
              centerLines={{
                line1: String(summary.remaining),
                line2: `of ${summary.total}`,
              }}
              height={140}
              sliceColors={{
                remaining: '#00685e',
                other: '#e8edf2'
              }}
            />
          </div>
          <div className="bsub-legend">
            {legendData.map(item => (
              <div key={item.name} className="bsub-legend-item">
                <span className="bsub-legend-dot" style={{ background: item.color }} />
                <span className="bsub-legend-label">{item.name}</span>
                <span className="bsub-legend-val">{item.value}</span>
              </div>
            ))}
          </div>
          <div className="bsub-actions">
            {isPurchaseEnabled() ? (
              <a href="/purchase" className="bsub-action-btn">
                <Icon type="shopping-cart" />
                Buy more subscriptions
              </a>
            ) : null}
            <a href={`mailto:${getPartnerContactEmail()}`} className="bsub-action-btn">
              <Icon type="mail" />
              Contact CC Team
            </a>
          </div>
        </div>

        {/* Right: stat cards — 1 row × 3 cols */}
        <div className="bsub-stat-grid bsub-stat-grid--3col">
          {statCards.map(card => (
            <div key={card.label} className={`bsub-stat-card bsub-stat-card--${card.mod}`}>
              <div className="bsub-stat-label">{card.label}</div>
              <div className="bsub-stat-value">{card.value}</div>
            </div>
          ))}
        </div>
      </div>
    </Spin>
  );
};

const mapStateToProps = state => ({
  userSubscriptionsSummary: userSubscriptionsSummarySelector(state),
  loading: loadingUserSubscriptionsSelector(state)
});

export default connect(mapStateToProps)(MySummary);
